import {
  resolveTimeBandAxisZoomSpanLimits,
  TimeBandXAxisOptions,
  TimeBandXAxisTimeUnit,
  useTimeBandXAxis,
  ZoomableTimeBandAxis,
} from "shared-ts-mui";
import { DateTimeUnit } from "luxon";
import { useMemo } from "react";

export const useXAxis = (
  timeAxis: ZoomableTimeBandAxis,
  timeUnit: DateTimeUnit,
  width: number | undefined
) => {
  const zoomSpanLimits = useMemo(
    () => resolveTimeBandAxisZoomSpanLimits(timeAxis, timeUnit, width),
    [timeUnit, width, timeAxis]
  );
  const options: TimeBandXAxisOptions = useMemo(
    () => ({
      grouping: {
        enabled: true,
        monthFormat: "MMM",
      },
      zoom:
        timeAxis.zoom === true || typeof timeAxis.zoom === "object"
          ? {
              minSpan: zoomSpanLimits.minSpan,
              maxSpan: zoomSpanLimits.maxSpan,
              slider: {
                enabled: true,
                preview: true,
              },
            }
          : undefined,
    }),
    [timeAxis.zoom, zoomSpanLimits.maxSpan, zoomSpanLimits.minSpan]
  );

  return useTimeBandXAxis(
    timeUnit as TimeBandXAxisTimeUnit,
    timeAxis.min,
    timeAxis.max,
    options
  );
};
